import React from 'react';
import { CardActions as KendoCardActions } from '@progress/kendo-react-layout';

/**
 * CardActions component wrapping KendoReact CardActions with all supported props.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.children] - CardActions children elements.
 * @param {string} [props.className] - Additional classes for the CardActions.
 * @param {string} [props.layout] - Layout of the actions ('start' | 'center' | 'end' | 'stretched').
 * @param {string} [props.orientation] - Orientation of the Card action buttons ('horizontal' | 'vertical').
 * @param {React.CSSProperties} [props.style] - Additional CSS styles.
 * @returns {JSX.Element}
 */
export const CardActions = ({
  children,
  className = '',
  layout,
  orientation,
  style = {}
}) => (
  <KendoCardActions
    className={className}
    layout={layout}
    orientation={orientation}
    style={style}
  >
    {children}
  </KendoCardActions>
);